import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Редактирование подрынка")
const _hoisted_2 = { class: "modal-form-input" }
const _hoisted_3 = { class: "upload-modal__footer" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Отмена")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Сохранить")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiInput = _resolveComponent("UiInput")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('close')))
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_UiInput, {
          label: "Наименование подрынка",
          inputId: "name",
          modelValue: _ctx.currentData.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentData.name) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_UiInput, {
          label: "Юридическое наименование",
          inputId: "legalName",
          modelValue: _ctx.currentData.legalName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentData.legalName) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_UiInput, {
          label: "ИНН",
          inputId: "inn",
          modelValue: _ctx.currentData.inn,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentData.inn) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_UiInput, {
          label: "Телефон администрации",
          inputId: "phone",
          modelValue: _ctx.currentData.phone,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentData.phone) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_UiInput, {
          label: "Территория(м2)",
          inputId: "area",
          modelValue: _ctx.currentData.area,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentData.area) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_UiInput, {
          label: "Кол-во сотрудников администрации рынка",
          inputId: "workersCount",
          modelValue: _ctx.currentData.workersCount,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.currentData.workersCount) = $event))
        }, null, 8, ["modelValue"])
      ])
    ]),
    controlButtons: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Btn, {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_Btn, {
          type: "primary",
          size: "large",
          onClick: _ctx.modalMarketState.submit
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }))
}